import React, { useState, useEffect } from "react";
import { FileJpgOutlined } from "@ant-design/icons";
import { message, Upload, Modal, Input } from "antd";
import LoadingOverlay from "react-loading-overlay";
import Swal from "sweetalert2";
import ClosedPassport from "./ClosedPassport";
import {countries} from 'country-data';

const swal = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  }
})
function formatBirthDate(dob) {
  const currentYear = new Date().getFullYear();
  let birthYear = parseInt(dob.substring(0, 2), 10);
  const month = parseInt(dob.substring(2, 4), 10);
  const day = parseInt(dob.substring(4), 10);

  // Adjust birth year for 90s based on current year
  if (birthYear > currentYear % 100) {
    birthYear += 1900;
  } else {
    birthYear += 2000;
  }

  // Validate birth year (between 1924 and current year)
  birthYear = Math.max(birthYear, 1924);
  birthYear = Math.min(birthYear, currentYear);

  // Get month name based on month number
  const months = [
    "January", "February", "March", "April",
    "May", "June", "July", "August",
    "September", "October", "November", "December"
  ];
  const monthName = months[month - 1];

  // Format the birth date
  const formattedDate = `${day < 10 ? '0' : ''}${day} ${monthName} ${birthYear}`;

  return formattedDate;
}

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

function App() {
  const [loading, setLoading] = useState(false);
  const [passportData, setPassportData] = useState({ isAdded: false })
  const handleFileChange = (e) => {
    let reader = new FileReader();
    reader.onload = (e) => {
      worker.postMessage({
        cmd: "process",
        image: e.target.result,
      });
    };
    if (e.target.files.length) {
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  var initWorker = () => {

    let blob = new Blob([window.mrz_worker.toString().replace(/^function .+\{?|\}$/g, "")], {
      type: "text/javascript",
    });
    let objectURL = URL.createObjectURL(blob);
    let newWorker = new Worker(objectURL);
    newWorker.addEventListener("message", (e) => {
      let data = e.data;
      setLoading(true)
      if (data.type === "result") {
        console.log("Result", data.result);
        setLoading(false)
        if (!data.result?.error) {
          setPassportData({
            isAdded: true,
            data: data?.result?.parsed?.fields,
            ocrized: data?.result?.ocrized
          });
        } else {
          swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: data.result?.error || 'Something went wrong!',
          })
        }

      } else if (data.type === "progress") {
        setLoading(true)
        // console.log("Progress");
      }
    });

    return newWorker;
  };

  let worker = initWorker();

  useEffect(() => {
    initWorker();
    return () => {
      // Clean up worker when component unmounts
      if (worker) {
        worker.terminate();
      }
    };
  }, []);

  return (
    <>
      <div className="grid grid-cols-2 grid-rows-2 gap-4">
        <LoadingOverlay active={loading} spinner text="Something Good is Happening..." styles={{
          overlay: (base) => ({
            ...base,
            borderRadius: "0.75rem",
          }),
        }}>
          <div className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 h-[640px]">
            <form className="w-full max-w-sm">
              <div className="md:flex md:items-center mb-6">
                <div className="md:w-3/3">
                  <Input type="file" onChange={handleFileChange} />
                </div>
              </div>
            </form>
          </div>
        </LoadingOverlay>
        <div className="bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 shadow-lg rounded-lg px-8 py-6 mb-4 text-center">
          {passportData.isAdded ? (
            <>
              <p className="text-white font-bold">
                MRZ:
                {
                  passportData.ocrized.map((data, index) => (
                    <span className={`text-black block`} key={index}>
                      {data}
                    </span>
                  ))
                }
              </p>
              <hr />
              <hr />
              <hr />
              <p className="text-gray-100 justify-center flex">Name:
                <p className="text-black ml-2">
                  {`${passportData.data?.firstName} ${passportData.data?.lastName}`}
                </p>
              </p>
              <p className="text-gray-100 justify-center flex">Document Code : 
                <p className="text-black ml-2">
                  {`${passportData.data?.documentCode}`}
                </p>
              </p>
              <p className="text-gray-100 justify-center flex">Issuing State : 
                <p className="text-black ml-2">
                  {`${passportData.data?.issuingState}`}
                </p>
              </p>
              <p className="text-gray-100 justify-center flex">Document Number : 
                <p className="text-black ml-2">
                  {`${passportData.data?.documentNumber}`}
                </p>
              </p>
              <p className="text-gray-100 justify-center flex">Document Number Checked Digit : 
                <p className="text-black ml-2">
                  {`${passportData.data?.documentNumberCheckDigit}`}
                </p>
              </p>
              
              <p className="text-gray-100 justify-center flex">Nationality : 
                <p className="text-black ml-2">
                  {countries[`${passportData.data?.nationality}`].name || 'Unknown'}
                  {/* {`${passportData.data?.nationality}`} */}
                </p>
              </p>
              
              <p className="text-gray-100 justify-center flex">Birth Date : 
                <p className="text-black ml-2">
                  {`${formatBirthDate(passportData.data?.birthDate)}`}
                </p>
              </p>
              <p className="text-gray-100 justify-center flex">Sex : 
                <p className="text-black ml-2">
                  {`${passportData.data?.sex}`}
                </p>
              </p>
              <p className="text-gray-100 justify-center flex">Passport Expiry Date : 
                <p className="text-black ml-2">
                  {`${formatBirthDate(passportData.data?.expirationDate)}`}
                </p>
              </p>
            </>
          ) : (
            <ClosedPassport />
          )}
        </div>


      </div>
    </>
  );
}

export default App;
